import helpers from 'helpers'

import * as yup from 'yup'
import constants from 'constants/index'

const schema = yup.object().shape({
  kind: yup.string().required(),
  type: yup.string().required(),
  fantasyName: yup.string().required().max(60),
  document: yup.string().required(),
  phone: yup
    .string()
    .required()
    .test('is-valid-phone', 'Número de telefone inválido', (value) => {
      return helpers.validates.phone.schema({ value, required: true })
    }),
  email: yup.string().required('Digite um E-mail valido'),
  segmentId: yup.string().when('origin', {
    is: (origin) => origin !== constants.preRegistration.EASY_ORIGIN,
    then: yup.string().required('Selecione um segmento'),
  }),
  typeTrial: yup.string().when('type', {
    is: constants.companies.TYPE_TRIAL,
    then: yup.string().required(),
  }),
  name: yup.string().when('kind', {
    is: constants.companies.KIND_COMPANY,
    then: yup.string().required().max(60),
  }),
  postalCode: yup.string().when('type', {
    is: constants.companies.TYPE_REAL,
    then: yup.string().required(),
  }),
  country: yup.string().when('type', {
    is: constants.companies.TYPE_REAL,
    then: yup.string().required(),
  }),
  state: yup.string().when('type', {
    is: constants.companies.TYPE_REAL,
    then: yup.string().required(),
  }),
  city: yup.string().when('type', {
    is: constants.companies.TYPE_REAL,
    then: yup.string().required(),
  }),
  neighborhood: yup.string().when('type', {
    is: constants.companies.TYPE_REAL,
    then: yup.string().required(),
  }),
  street: yup.string().when('type', {
    is: constants.companies.TYPE_REAL,
    then: yup.string().required(),
  }),
  number: yup.string().when('type', {
    is: constants.companies.TYPE_REAL,
    then: yup.string().required(),
  }),
  complement: yup.string(),
  sellerId: yup.string().when('origin', {
    is: (origin) => origin !== constants.preRegistration.EASY_ORIGIN,
    then: yup.string().required('Selecione um plano'),
  }),
  endDate: yup.date().when('type', {
    is: constants.companies.TYPE_TRIAL,
    then: yup.date().required().typeError('Confirme uma data'),
  }),
  responsibleName: yup.string().required(),
  responsibleEmail: yup.string().email().required(),
  responsiblePhone: yup
    .string()
    .required()
    .test('is-valid-phone', 'Número de telefone inválido', (value) => {
      return helpers.validates.phone.schema({ value, required: true })
    }),
  planId: yup.number().when('origin', {
    is: (origin) => origin !== constants.preRegistration.EASY_ORIGIN,
    then: yup.number().required('Selecione um plano'),
  }),
})

export default schema
